import { RELICS } from './relics';

export const createBossUpgradeRolls = (game, random = Math.random) => {
  const rolls = {};
  game.relics.forEach((id) => {
    const relic = RELICS[id];
    if (relic?.bossRandomDamage)
      rolls[id] = { damage: 1 + Math.floor(random() * relic.bossRandomDamage) };
    if (relic?.bossRandomBlock)
      rolls[id] = { block: Math.floor(random() * (relic.bossRandomBlock + 1)) };
    if (relic?.bossRandomHeal)
      rolls[id] = { heal: Math.floor(random() * (relic.bossRandomHeal + 1)) };
    if (relic?.bossDoubleChance)
      rolls[id] = { critical: random() < relic.bossDoubleChance };
  });
  return rolls;
};
